import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QQQuestionnairePageViewModel } from 'src/app/models/qq-questionnaire-page.view-model';

@Component({
  selector: 'app-apg-quick-quote-page',
  templateUrl: './apg-quick-quote-page.component.html',
  styleUrls: ['./apg-quick-quote-page.component.scss'],
})
export class ApgQuickQuotePageComponent implements OnInit {
  @Input() page: QQQuestionnairePageViewModel;
  @Input() firstPage: boolean;
  @Output() opened = new EventEmitter<string>();
  @Output() findExisting = new EventEmitter();

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  showInvalid() {
    setTimeout(() => {
      const invalidControl = this.el.nativeElement.querySelector('.has-error');
      if (invalidControl) {
        invalidControl.scrollIntoView();
      }
    });
  }
}
